"use strict"
const { AppDispatcher } = require("@cirrus/legacy/app-common/dispatcher")

module.exports = {
  changeTitle: function (data) {
    AppDispatcher.dispatch({
      type: "CHANGE_PAGE_TITLE",
      data: {
        title: data.title,
        icon: data.icon,
      },
    })
  },
  changeTitleStepwise: function (data) {
    var template = data.modelTitle ? "{modelTitle} - {stepTitle}" : "{stepTitle}"

    var title = template
      .replace("{modelTitle}", data.modelTitle)
      .replace("{stepTitle}", data.stepTitle.charAt(0).toUpperCase() + data.stepTitle.substr(1))

    AppDispatcher.dispatch({
      type: "CHANGE_PAGE_TITLE",
      data: {
        title: title,
      },
    })
  },
  changeTitleEvaluationResults: function (data) {
    var template = "{scheduleTitle} - {tabTitle}",
      title = null

    title = template
      .replace("{scheduleTitle}", data.scheduleTitle)
      .replace("{tabTitle}", data.tabTitle.charAt(0).toUpperCase() + data.tabTitle.substr(1))

    AppDispatcher.dispatch({
      type: "CHANGE_PAGE_TITLE",
      data: {
        title: title,
      },
    })
  },
  cleanTitle: function () {
    AppDispatcher.dispatch({
      type: "CHANGE_PAGE_TITLE",
      data: {
        title: null,
        icon: null,
      },
    })
  },
}
